import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allVisionProjects }) => {
  return state.merge({ allVisionProjects });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const setVideos = (state, { allVideos }) => {
  return state.merge({ allVideos });
};
const setTrainingProgress = (state, { trainingProgress }) => {
  return state.merge({ trainingProgress });
};
const setTrainingData = (state, { trainingData }) => {
  return state.merge({ trainingData });
};
const setModalLoader = (state, { showModalLoader }) => {
  return state.merge({ showModalLoader });
};
const setAllUseCases = (state, { useCases }) => {
  return state.merge({ useCases });
};
const setProjectDetails = (state, { projectDetails }) => {
  return state.merge({ projectDetails });
};
const setProjectStatusOverview = (state, { projectStatusOverview }) => {
  return state.merge({ projectStatusOverview });
};
const setImages = (state, { allImages }) => {
  return state.merge({ allImages });
};
const setImageTableLoaderStatus = (state, { showTableLoader }) => {
  return state.merge({ showTableLoader });
};
const setVideoTableLoaderStatus = (state, { showVideoTableLoader }) => {
  return state.merge({ showVideoTableLoader });
};
const setImageAnnotations = (state, { imageAnnotations }) => {
  return state.merge({ imageAnnotations });
};
const setTestModelResult = (state, { testModelResult }) => {
  return state.merge({ testModelResult });
};
const setDeployedVisionProjects = (state, { deployedVisionProjects }) => {
  return state.merge({ deployedVisionProjects });
};
const setJobVisionEquipmentConfig = (state, { missedList }) => {
  return state.merge({ missedList });
};
const setEquipmentProjects = (state, { equipmentProjects }) => {
  return state.merge({ equipmentProjects });
};
const setDeploymentHistoryLoader = (state, { showDeploymentHistoryLoader }) => {
  return state.merge({ showDeploymentHistoryLoader });
};
const setDeploymentHistory = (state, { allDeploymentHistory }) => {
  return state.merge({ allDeploymentHistory });
};
const setCameraStatus = (state, { cameraStatus }) => {
  return state.merge({ cameraStatus });
};
const setCameraStatusLoader = (state, { showCameraStatusLoader }) => {
  return state.merge({ showCameraStatusLoader });
};
const setImageFromS3Bucket = (state, { imageData }) => {
  const normalizedImageData = Immutable.isImmutable(imageData) ? imageData : Immutable.fromJS(imageData || []);
  return state.merge({ imageData: normalizedImageData });
};
const setUploadImageLoader = (state, { showUploadImageLoader }) => {
  return state.merge({ showUploadImageLoader });
};
const setDeleteImageLoader = (state, { showDeleteImageLoader }) => {
  return state.merge({ showDeleteImageLoader });
};
const setImageCaptureProcessed = (state, { isProcessed }) => {
  return state.merge({ isProcessed });
};
const setStartStopLoader = (state, { showStartStopLoader }) => {
  return state.merge({ showStartStopLoader });
};
const setDeleteAllLoader = (state, { showDeleteAllLoader }) => {
  return state.merge({ showDeleteAllLoader });
};
const setMediaUploadResult = (state, { mediaUploadResult }) => {
  return state.merge({ mediaUploadResult });
};
const setTrainingHistoryLoader = (state, { showTrainingHistoryLoader }) => {
  return state.merge({ showTrainingHistoryLoader });
};
const setTrainingHistory = (state, { allTrainingHistory }) => {
  return state.merge({ allTrainingHistory });
};
const setVisionProjectStatus = (state, { status }) => {
  return state.merge({ visionProjectStatus: status });
};

const setVisionAiTools = (state, { visionProjectAiTools }) => {
  return state.merge({ visionProjectAiTools });
};

// Reducer functions for Global AOIs and Customer AOIs
const setAllGlobalAois = (state, { allGlobalAois }) => {
  return state.merge({ allGlobalAois });
};

const setCustomerAois = (state, { customerAois }) => {
  return state.merge({ customerAois });
};

const setLabelsList = (state, { labelsList }) => {
  return state.merge({ labelsList });
};

const setTempAnnotations = (state, { tempAnnotations }) => {
  return state.merge({ tempAnnotations });
};

const setProductGroups = (state, { productGroups }) => {
  return state.merge({ productGroups });
};

const setProductImages = (state, { productImages }) => {
  return state.merge({ productImages });
};

// Augmentation tools reducer functions
const setAugmentationTools = (state, { augmentationTools }) => {
  return state.merge({ augmentationTools });
};

const setAugmentationToolsLoader = (state, { showAugToolsLoader }) => {
  return state.merge({ showAugToolsLoader });
};

const setUsedAoiNames = (state, { data }) => {
  return state.merge({ usedAoiNames: data });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_MODAL_LOADER_STATUS,
    actionFunction: setModalLoader,
  },
  {
    actionType: ActionTypes.SET_VISION_PROJECT_VIDEOS,
    actionFunction: setVideos,
  },
  {
    actionType: ActionTypes.SET_TRAINING_DATA,
    actionFunction: setTrainingData,
  },
  {
    actionType: ActionTypes.SET_TRAINING_PROGRESS,
    actionFunction: setTrainingProgress,
  },
  {
    actionType: ActionTypes.SET_ALL_USE_CASES,
    actionFunction: setAllUseCases,
  },
  {
    actionType: ActionTypes.SET_PROJECT_DETAILS,
    actionFunction: setProjectDetails,
  },
  {
    actionType: ActionTypes.SET_PROJECT_STATUS_OVERVIEW,
    actionFunction: setProjectStatusOverview,
  },
  {
    actionType: ActionTypes.SET_VISION_PROJECT_IMAGES,
    actionFunction: setImages,
  },
  {
    actionType: ActionTypes.SET_IMAGE_TABLE_LOADER_STATUS,
    actionFunction: setImageTableLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_VIDEO_TABLE_LOADER_STATUS,
    actionFunction: setVideoTableLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_IMAGE_ANNOTATIONS,
    actionFunction: setImageAnnotations,
  },
  {
    actionType: ActionTypes.SET_TEST_MODEL_RESULT,
    actionFunction: setTestModelResult,
  },
  {
    actionType: ActionTypes.SET_DEPLOYED_VISION_PROJECTS,
    actionFunction: setDeployedVisionProjects,
  },
  {
    actionType: ActionTypes.SET_JOB_VISION_EQUIPMENT_CONFIG,
    actionFunction: setJobVisionEquipmentConfig,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_PROJECTS,
    actionFunction: setEquipmentProjects,
  },
  {
    actionType: ActionTypes.SET_DEPLOYMENT_HISTORY_LOADER_STATUS,
    actionFunction: setDeploymentHistoryLoader,
  },
  {
    actionType: ActionTypes.SET_VISION_PROJECT_DEPLOYMENT_HISTORY,
    actionFunction: setDeploymentHistory,
  },
  {
    actionType: ActionTypes.SET_CAMERA_STATUS,
    actionFunction: setCameraStatus,
  },
  {
    actionType: ActionTypes.SET_CAMERA_STATUS_LOADER,
    actionFunction: setCameraStatusLoader,
  },
  {
    actionType: ActionTypes.SET_IMAGE_FROM_S3_BUCKET,
    actionFunction: setImageFromS3Bucket,
  },
  {
    actionType: ActionTypes.SET_UPLOAD_IMAGE_LOADER,
    actionFunction: setUploadImageLoader,
  },
  {
    actionType: ActionTypes.SET_IMAGE_CAPTURE_PROCESSED,
    actionFunction: setImageCaptureProcessed,
  },
  {
    actionType: ActionTypes.SET_START_STOP_LOADER,
    actionFunction: setStartStopLoader,
  },
  {
    actionType: ActionTypes.SET_DELETE_ALL_LOADER,
    actionFunction: setDeleteAllLoader,
  },
  {
    actionType: ActionTypes.SET_MEDIA_UPLOAD_RESULT,
    actionFunction: setMediaUploadResult,
  },
  {
    actionType: ActionTypes.SET_TRAINING_HISTORY_LOADER_STATUS,
    actionFunction: setTrainingHistoryLoader,
  },
  {
    actionType: ActionTypes.SET_VISION_PROJECT_TRAINING_HISTORY,
    actionFunction: setTrainingHistory,
  },
  {
    actionType: ActionTypes.SET_VISION_PROJECT_STATUS,
    actionFunction: setVisionProjectStatus,
  },
  {
    actionType: ActionTypes.SET_DELETE_IMAGE_LOADER,
    actionFunction: setDeleteImageLoader,
  },
  {
    actionType: ActionTypes.SET_VISION_AI_TOOLS,
    actionFunction: setVisionAiTools,
  },
  // Global AOIs and Customer AOIs callbacks
  {
    actionType: ActionTypes.SET_ALL_GLOBAL_AOIS,
    actionFunction: setAllGlobalAois,
  },
  {
    actionType: ActionTypes.SET_CUSTOMER_AOIS,
    actionFunction: setCustomerAois,
  },
  {
    actionType: ActionTypes.SET_LABELS_LIST,
    actionFunction: setLabelsList,
  },
  {
    actionType: ActionTypes.SET_TEMP_ANNOTATIONS,
    actionFunction: setTempAnnotations,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_GROUPS,
    actionFunction: setProductGroups,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_IMAGES,
    actionFunction: setProductImages,
  },
  // Augmentation tools callbacks
  {
    actionType: ActionTypes.SET_AUGMENTATION_TOOLS,
    actionFunction: setAugmentationTools,
  },
  {
    actionType: ActionTypes.SET_AUGMENTATION_TOOLS_LOADER,
    actionFunction: setAugmentationToolsLoader,
  },
  {
    actionType: ActionTypes.SET_USED_AOI_NAMES,
    actionFunction: setUsedAoiNames,
  },
];
